import ProcessDsfr from "components/templates/processDsfr/ProcessDsfr";
import elementsTypes from "utils/elementsTypes";

export default {
  key: "PROCESSDSFR",
  label: "Démarche (DSFR)",
  Component: ProcessDsfr,
  initialContents: [
    {
      key: "hasMobileDemarche",
      type: elementsTypes.ALONE_CHECKBOX_PROCESS_DSFR,
      value: "false",
    },
    {
      key: "browserDemarche",
      type: elementsTypes.TEXT_ICON,
      value: "",
      children: [
        {
          key: "text",
          value: "Faire cette démarche depuis mon ordinateur",
        },
        {
          key: "icon",
          type: elementsTypes.ICON,
          value: "",
          children: [
            {
              key: "iconDSFR",
              type: elementsTypes.INPUT,
              value: "global-line",
            },
          ],
        },
      ],
    },
    {
      key: "mobileDemarche",
      type: elementsTypes.TEXT_ICON,
      value: "",
      children: [
        {
          key: "text",
          value: "Faire cette démarche depuis l’application mobile « Simplimmat.gouv »",
        },
        {
          key: "icon",
          type: elementsTypes.ICON,
          value: "",
          children: [
            {
              key: "iconDSFR",
              type: elementsTypes.INPUT,
              value: "smartphone-line",
            },
          ],
        },
      ],
    },

    {
      key: "storeLinks",
      type: elementsTypes.STORE_BUTTONS,
      value: "",
    },

    {
      key: "browserDemarcheButton",
      value: "",
      type: elementsTypes.BUTTON,
      children: [
        {
          key: "text",
          type: elementsTypes.INPUT,
          value: "Commencer cette démarche en ligne",
        },
        {
          key: "link",
          type: elementsTypes.LINK,
          value: "",
          children: [
            {
              key: "url",
              type: elementsTypes.URL,
              value: "",
            },
            {
              type: elementsTypes.CHECKBOX,
              key: "external",
              value: "false",
            },
          ],
        },
        {
          key: "primary",
          type: elementsTypes.CHECKBOX,
          value: "true",
        },
      ],
    },

    {
      key: "dynamicItem",
      type: elementsTypes.DYNAMIC_LIST,
      value: "",
      children: [
        {
          key: "buttonElementText",
          value: "un lien",
        },
        {
          key: "limit",
          value: "1",
        },
        {
          key: "contentType",
          value: [elementsTypes.ICON_LINK].toString(),
        },
      ],
    },
    {
      key: "alertInfo",
      type: elementsTypes.DYNAMIC_LIST,
      value: "",
      children: [
        {
          key: "buttonElementText",
          value: "une alerte",
        },
        {
          key: "limit",
          value: "1",
        },
        {
          key: "contentType",
          value: [elementsTypes.ALERT].toString(),
        },
      ],
    },
    {
      key: "displayAlternative",
      type: elementsTypes.ALONE_CHECKBOX_NO_LABEL,
      value: "true",
    },
    {
      key: "displaySummary",
      type: elementsTypes.ALONE_CHECKBOX_SUMMARY,
      value: "true",
    },
    {
      key: "stepper",
      type: elementsTypes.STEPPER_DSFR,
      value: "",
      children: [],
    },
    {
      key: "dynamicPart",
      type: elementsTypes.DYNAMIC,
      value: "",
      children: [],
    },
  ],
};
